import { useState } from "react";
import { faqs } from "@/mocks/gossip";
import { SectionHead } from "./ui";

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }} />
      <div className="mx-auto max-w-[860px] px-4 py-10 md:px-6 md:py-16">
        <SectionHead
          eyebrow="FAQ · 常见问题"
          title="关于追瓜，你可能想问"
          sub="关于信息来源、实锤标准与网站定位，这里给出编辑部最诚恳的回答。"
        />
        <div className="space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition ${
                  open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-100/50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <h3 className={`flex-1 text-sm font-semibold md:text-base ${open ? "text-primary-700" : "text-foreground-900"}`}>
                    {f.q}
                  </h3>
                  <span
                    className={`grid h-8 w-8 shrink-0 place-items-center rounded-full transition ${
                      open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    <i className={`text-sm transition-transform ${open ? "ri-subtract-line" : "ri-add-line"}`} />
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5 md:px-6">
                    <p className="border-l-2 border-primary-200 pl-4 text-sm leading-7 text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}